import { PageAnchor } from 'src/app/AppAuth/PageAnchor'
import palette from 'src/designSystem/variables/palette'
import styled from 'styled-components/macro'

export const StyledExternalLink = styled(PageAnchor)<{
  $underline?: boolean
}>`
  text-decoration: none;
  font-weight: 500;
  width: content-fit;
  ${({ $underline }) => $underline && 'text-decoration: underline;'}
`

export const StyledExternalPageLink = styled(StyledExternalLink).attrs({
  target: '_blank',
  rel: 'noreferrer',
})<{
  $color?: string
  $darkBg?: boolean
}>`
  color: ${({ $color, $darkBg }) =>
    $color || $darkBg ? palette.blue[100] : palette.blue[700]};

  &:visited {
    color: ${({ $color, $darkBg }) =>
      $color || $darkBg ? palette.blue[100] : palette.blue[700]};
  }
`
